import { requestGet as wsRequestGet } from './_wsApiFetchData';

const BASE = '/admin/PlayGamesAdmin';

// status: optional PlayGameStatus name (Open, Confirmed, Cancelled, ...).
export async function list({ status, take } = {}, language, timeZone, cancelToken) {
  const params = new URLSearchParams();
  if (status) params.set('status', status);
  if (take) params.set('take', String(take));
  const qs = params.toString();
  return wsRequestGet(qs ? `${BASE}?${qs}` : BASE, language, timeZone, null, cancelToken);
}

export async function get(code, language, timeZone, cancelToken) {
  return wsRequestGet(`${BASE}/${encodeURIComponent(code)}`, language, timeZone, null, cancelToken);
}
